<div class="container p-4 min-h-screen">
  <!-- account -->
  <div class="flex flex-row">
    <fa-icon [icon]="userCircle"></fa-icon>
    &nbsp;{{ (auth.user$ | async)?.name }}&nbsp;|&nbsp;<button
      class="text-primary-500"
      (click)="auth.signout()"
    >
      Abmelden
    </button>
  </div>
  <!-- info -->
    <div class="my-4">
        <h1 class="text-xl font-medium mb-1">
            Willkommen, {{ (auth.user$ | async)?.name }}
        </h1>
        <p class="mb-2">
            In der Schenk Service App können Sie Tickets erstellen, welche direkt an
            den richtigen Mitarbeiter der Schenk Sonnenschutztechnik GmbH verteilt
            werden. Anschließend wird sich einer unserer Mitarbeiter bei Ihnen unter
            der E-Mail Adresse {{ (auth.user$ | async)?.mail }} melden.
        </p>
        <p class="text-gray-700 text-xs">
            Stimmt diese E-Mail Adresse nicht, schreiben sie bitte eine E-Mail an
            <a class="text-gray-900" href="mailto:info@schenk-sonnenschutztechnik.de"
                >info@schenk-sonnenschutztechnik.de</a>
        </p>
    </div>
    <!-- admin info -->
    <div *ngIf="(auth.user$ | async)?.admin" class="my-4">
        <a routerLink="/admin" class="btn btn-info w-full flex flex-row justify-start">
            <div class="flex flex-col items-start justify-center">
                <span class="font-normal text-xs block -mb-1">Sie sind Admin</span>
                <span>Zum Adminbereich <fa-icon [icon]="longArrowRight"></fa-icon></span>
            </div>
        </a>
    </div>
  <!-- tickets -->
  <div class="flex flex-col mt-4">
    <app-new-ticket
      *ngIf="auth.user$ | async as user"
      [user]="user"
    ></app-new-ticket>
    <!-- overview -->
    <hr class="mt-8 mb-4" />
    <h2 class="text-xl font-medium mb-2">
      Meine Tickets<span class="font-normal">
        - {{ (ticketService.tickets$ | async)?.length }}</span
      >
    </h2>
    <app-ticket
      class="mb-2"
      *ngFor="let ticket of ticketService.tickets$ | async"
      [ticket]="ticket"
    ></app-ticket>
  </div>
  <span class="block mt-4 text-xs text-gray-600 w-full text-center mb-4">
    1.3
  </span>
</div>
